import { api } from "./api";

export const newChat = async (data: any) => {
    return api.post(`/user/newchat`, data)
}

export const userActiveSession = async (phone: string) => {
    return api.get(`/user/activeSession/${phone}`)
}

const chatApi = {
    newChat,
    userActiveSession,
}

export default chatApi;